/**
 * UNVERIFIED-CANDIDATES-1 (2026-09-23): a separate research tier for cars the model scored
 * positively that source verification then set to zero only because the dealer page could
 * not be read automatically. Measured on production: 795 cars had a positive model score
 * before source verification and 198 were published as recommendations; mobile.de pages
 * were 0/86 readable (bot challenge), Vivacar.fr 0/71, AutoScout24 122/289. An unreadable
 * page says nothing about the car, so these deserve a manual look. They are still not
 * recommendations and must never borrow a recommendation's green cues.
 *
 * Blocked rows zeroed for a real negative reason, such as "the seller has raised the price
 * since our snapshot", stay out: their reason does not start with the source-verification
 * prefix. The recommendation and discovery definitions are untouched. This tier is the
 * contract discovery population plus UNVERIFIED_CANDIDATE_CLAUSE and the buyer's own
 * vehicle and budget filters.
 */
// 'na' = the dealer page was never checked (the per-brand source-check cap), which is the same
// gap for the buyer as an unreadable page (added 2026-10-01).
export const UNVERIFIED_SOURCE_FLAGS = Object.freeze(['blocked', 'unresolved', 'na'])
// A prefix, not a substring. PocketBase `~` with an explicit % is LIKE 'prefix%', so a
// compound reason that mentions source verification after a negative verdict stays out.
export const UNVERIFIED_REASON_PREFIX = 'source verification:'
// CASH-PRICE-1 (2026-10-01): the page WAS read, but in a market where finance-conditional dealer
// prices are common it did not confirm a cash price. The only 'live' row this tier admits.
export const CASH_PRICE_REASON_PREFIX = 'source verification: cash price unconfirmed'
export const UNVERIFIED_CANDIDATE_CLAUSE =
  `((${UNVERIFIED_SOURCE_FLAGS.map(flag => `source_flag = '${flag}'`).join(' || ')})` +
  ` && buy_reason ~ '${UNVERIFIED_REASON_PREFIX}%'` +
  ` || source_flag = 'live' && buy_reason ~ '${CASH_PRICE_REASON_PREFIX}%')`

/** Row-level mirror of UNVERIFIED_CANDIDATE_CLAUSE: an exact flag (SQL `=` is case
 * sensitive) and a reason that starts with the prefix (SQL LIKE ignores ASCII case). */
export function isUnverifiedCandidate(row) {
  const reason = row?.buy_reason
  if (typeof reason !== 'string') return false
  const lower = reason.toLowerCase()
  return (UNVERIFIED_SOURCE_FLAGS.includes(row?.source_flag) && lower.startsWith(UNVERIFIED_REASON_PREFIX))
    || (row?.source_flag === 'live' && lower.startsWith(CASH_PRICE_REASON_PREFIX))
}
